import { getUserClient } from '@/api'

// ponytail: raw Cognito calls so the admin's own Amplify session stays untouched
const cognito = async (region: string, target: string, body: object) => {
  const res = await fetch(`https://cognito-idp.${region}.amazonaws.com/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-amz-json-1.1',
      'X-Amz-Target': `AWSCognitoIdentityProviderService.${target}`
    },
    body: JSON.stringify(body)
  })
  const data = await res.json()

  if (!res.ok) throw new Error(data.message ?? data.__type ?? 'Cognito error')

  return data
}

/** Exchanges a one-time login_as_token for the target user's Cognito id token. */
export const exchangeLoginAsToken = async (
  loginAsToken: string,
  email: string,
  orgId: string
): Promise<string> => {
  const { admin_email } = JSON.parse(
    atob(loginAsToken.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))
  )
  const metadata = { admin_email }

  const res = await getUserClient().getUserLoginParameters(email)
  const params = res.data.login_parameters?.find(
    (p) => p.organization_id === orgId
  )

  if (!params?.cognito_region) throw new Error('No login parameters for org')

  const { cognito_region: region, cognito_user_pool_client_id: clientId } =
    params

  const challenge = await cognito(region, 'InitiateAuth', {
    AuthFlow: 'CUSTOM_AUTH',
    ClientId: clientId,
    AuthParameters: { USERNAME: email },
    ClientMetadata: metadata
  })

  const auth = await cognito(region, 'RespondToAuthChallenge', {
    ChallengeName: 'CUSTOM_CHALLENGE',
    ClientId: clientId,
    Session: challenge.Session,
    ChallengeResponses: {
      USERNAME: challenge.ChallengeParameters?.USERNAME ?? email,
      ANSWER: loginAsToken
    },
    ClientMetadata: metadata
  })

  const idToken = auth.AuthenticationResult?.IdToken

  if (!idToken) throw new Error('Additional challenge required')

  return idToken
}
